<script setup>
import { computed, ref } from 'vue';
import {
  ApplicationWrapper,
  LocationSelector,
  usePermissions,
} from '@/myq-core';
import useRoutes from '@/views/routes';
import { useRoute } from 'vue-router';

const routes = useRoutes();

const component = ref();
const singleLocation = computed(() => component?.value?.singleLocation);
const coldScopes = computed(() => component?.value?.coldScopes);
const disableLocationSelector = computed(
  () => component?.value?.disableLocationSelector,
);
const hidePageHeader = computed(() => component?.value?.hidePageHeader);
const hideSideBar = computed(() => component?.value?.hideSideBar);
const onlyActiveLocations = computed(
  () => component?.value?.onlyActiveLocations || false,
);

const route = useRoute();
const customHasPermission = computed(() => {
  if (
    ['/home-dashboard', '/', '/reports/mcd/dashboardtest'].includes(route.path)
  ) {
    return true;
  }
  if (
    ['/businessUnitBI', '/businessUnitBI/customRequestForm'].includes(
      route.path,
    )
  ) {
    const { hasPermission } = usePermissions('bu_quicksight_access');
    return hasPermission.value;
  }
  if (route.path === '/qsrConnect') {
    const { hasPermission } = usePermissions('qsrconnect_access');
    return hasPermission.value;
  }
  if (route.path === '/customerRecovery/dashboard') {
    const { hasPermission } = usePermissions('customer_feedback_access');
    return hasPermission.value;
  }
  const { hasPermission } = usePermissions('reports_access');
  return hasPermission.value;
});
const customOrgAccess = computed(() => {
  if (['/home-dashboard', '/'].includes(route.path)) {
    return true;
  }
  if (
    ['/businessUnitBI', '/businessUnitBI/customRequestForm'].includes(
      route.path,
    )
  ) {
    return true;
  }
  if (route.path === '/qsrConnect') {
    const { orgHasApp } = usePermissions('qsrconnect');
    return orgHasApp.value;
  }

  if (route.path === '/calendar') {
    return true;
  }

  if (route.path === '/customerRecovery/dashboard') {
    const { orgHasApp } = usePermissions('myq_ops');
    return orgHasApp.value;
  }
  const { orgHasApp } = usePermissions('reports');
  return orgHasApp.value;
});
</script>

<template>
  <ApplicationWrapper
    :routes="routes"
    useCustomOrgAccess
    useCustomHasPermission
    :customOrgAccess="customOrgAccess"
    :customHasPermission="customHasPermission"
    :hidePageHeader="hidePageHeader"
    :hideSideBar="hideSideBar"
  >
    <template v-slot:top-nav v-if="!disableLocationSelector">
      <LocationSelector
        :hotReload="!coldScopes"
        :singleLocation="singleLocation"
        :onlyActiveLocations="onlyActiveLocations"
      />
    </template>
    <router-view v-slot="{ Component }">
      <component :is="Component" ref="component" />
    </router-view>
  </ApplicationWrapper>
</template>
